export enum SubContext {
  PromoBundleLander = 'PromoBundleLander',
  CartLineItem = 'CartLineItem',
  CollectionsSet = 'CollectionsSet',
  CompleteTheLook = 'CompleteTheLook',
  GlobalCartPage = 'GlobalCartPage',
  PromoCartUpsell = 'PromoCartUpsell',
  PromoCartColorUpsell = 'PromoCartColorUpsell',
  ProductFormButton = 'ProductFormButton',
  ProductControls = 'ProductControls',
  RelatedItem = 'Related item',
  IconProductSelector = 'Icon product selector',
  MobileMenu = 'Mobile Menu',
  DesktopMenu = 'Desktop Menu',
  FooterSizingToolProductSelector = 'Footer Sizing tool product selector',
  HomePageHero = 'Home Page Hero',
  HomePageCarousel = 'Home Page Carousel',
  LanderProductToggle = 'Lander Product Toggle',
  None = '',
}
